import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-6 error--text"
}
const _hoisted_2 = {
  key: 1,
  class: "input-number-inc-container mt-1"
}
const _hoisted_3 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          class: "input-label",
          style: _normalizeStyle({ paddingLeft: Object.keys(_ctx.$attrs).includes('prepend-icon') ? '42px' : '0px' })
        }, [
          _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
          (_ctx.showRequired)
            ? (_openBlock(), _createElementBlock("small", _hoisted_1, "*"))
            : _createCommentVNode("", true)
        ], 4))
      : _createCommentVNode("", true),
    _createVNode(_component_v_text_field, _mergeProps({ ref: "inputText" }, _ctx.$attrs, {
      rules: _ctx.rule,
      "model-value": _ctx.modelValue,
      "onUpdate:modelValue": _ctx.valueChanged,
      onFocus: _cache[0] || (_cache[0] = ($event: any) => (_ctx.focused = true)),
      onBlur: _ctx.focousout,
      "hide-details": _ctx.disableDetails || (_ctx.focused == true && _ctx.showNumberIncSuggestion)
    }), null, 16, ["rules", "model-value", "onUpdate:modelValue", "onBlur", "hide-details"]),
    (_ctx.type == 'number' && _ctx.showNumberIncSuggestion && _ctx.focused)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stepsList, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "input-number-inc-box"
            }, [
              _createElementVNode("span", {
                class: "input-number-inc-btn",
                outlined: "",
                onClick: _withModifiers(($event: any) => (_ctx.handleIncClick($event, item)), ["prevent"])
              }, _toDisplayString(item), 9, _hoisted_3)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ])), [
    [_directive_click_outside, _ctx.focousout]
  ])
}